import React, { Component } from 'react';
import { Layout, Image, Typography } from 'antd';
import { Link } from 'react-router-dom';
import axios from 'axios';
import './Movies.css'

const Content = Layout;
const {Title} = Typography


class Movies extends Component {
  constructor(props) {
    super(props)
    this.state = {
      movies : [],
      trigger : true
    }
  }

  componentDidMount() {
    if(this.state.trigger) {
      const getMovies = async () => {
        const result = await axios.get("https://backendexample.sanbersy.com/api/data-movie")
        this.setState({
          movies: [...result.data]
        })
        this.setState({
          trigger: false
        })
      }
      getMovies()
    }
  }

  render() {
    const movies = this.state.movies
    return (
      <Content className="site-layout" style={{ padding: '0 50px', marginTop: 64 }}>
        <div id="movies-page">
          <Title level={2}>
            Movies
          </Title>
          <div className="movies">
            {
              movies.map((el) => 
                <div className="movie">
                  <Image
                    src={el.image_url}
                    preview={false}
                    height={"20em"}
                    width={"15em"}
                  />
                  <Link to={`detail/movie/${el.id}`}>
                    <h3 className="movie-title">{el.title}</h3>
                  </Link>
                </div>
              )
            }
          </div>
        </div>
      </Content>
    )
  }
}

export default Movies